import { SortSelection } from "@bundles/parts"
import { SORTING_MODES } from "@bundles/parts/components/ListV2/ArticleListConfiguration"
import { useDispatch, useSelector } from "react-redux"
import { MainState } from "../main"
import { Actions } from "../wheels-list/business"

const sortingModes = {
    default: SORTING_MODES.default,
    price: SORTING_MODES.price,
    priceDescending: SORTING_MODES.priceDescending,
}

export type RimSorting = keyof typeof sortingModes
const selectedRimSort = (state: MainState) => state.wheelsList.base.selectedRimSort

export function RimSortDropdown() {
    const selectedSort = useSelector(selectedRimSort)
    const dispatch = useDispatch()

    const handleChange = (newValue: RimSorting) => {
        dispatch(Actions.changeRimSorting(newValue))
    }

    return <SortSelection sortingModes={sortingModes} value={selectedSort} onChange={handleChange} />
}
